import { DateFormatValueConverter } from '~/converters/date-format';

/**
 * LocalizedDateTimeFormats defines all the localized the date/time/datetime formats supported by the WebUI
 * Please avoid adding more types without discussing with the WebUI team
 */
export enum LocalizedDateTimeFormats {
	/**
	 * Date format: 09/04/1986
	 * It's the default date format in UI
	 * The format must match the format from {@link DateFormatValueConverter.toFlatpickrLocaleDateFormat()}
	 */
	Date = 'L',
	/**
	 * Date format: 09/04/1986
	 * Please do not use it without discussing with the WebUI team
	 */
	DateShort = 'l',
	/**
	 * Date Time format: 09/04/1986 8:30 PM
	 * It's the default date and time format in UI, which
	 * has been applied for Created DateTime Modified DateTime
	 * The format must match the format from {@link DateFormatValueConverter.toFlatpickrLocaleDateTimeFormat()}
	 */
	DateTime = 'L LT',
	/**
	 * Date Time with format: 09/04/1986 8:30:25 PM
	 * It's the special format when seconds are important, e.g. the request date in `api-audit.ts`.
	 * The format must match the format from {@link DateFormatValueConverter.toFlatpickrLocaleDateTimeFormat()}
	 * Please use it only when required
	 */
	DateTimeWithSeconds = 'L HH:mm:ss',
	/**
	 * Time format: 8:30 PM
	 * Default Time format used in UI
	 */
	Time = 'LT',
	/**
	 * Time with seconds format: 8:30:25 PM
	 * Please use it only when required
	 */
	TimeWithSeconds = 'LTS',
}
